import { render, staticRenderFns } from "./BvAlertBanner.vue?vue&type=template&id=0f12045e&"
import script from "./BvAlertBanner.vue?vue&type=script&lang=ts&"
export * from "./BvAlertBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports